const GC = window.__GENERATED_CONSTANTS__

export const ReportGroupingLevel = {
    NONE: GC.ReportGroupingLevel.NONE,

    USER: GC.ReportGroupingLevel.USER,
    USER_GROUP: GC.ReportGroupingLevel.USER_GROUP,
    TIME_ZONE_GROUP: GC.ReportGroupingLevel.TIME_ZONE_GROUP,
    LEAVE_TYPE: GC.ReportGroupingLevel.LEAVE_TYPE,
    USER_RATE: GC.ReportGroupingLevel.USER_RATE,

    CUSTOMER: GC.ReportGroupingLevel.CUSTOMER,
    PROJECT: GC.ReportGroupingLevel.PROJECT,
    PROJECT_NAME: GC.ReportGroupingLevel.PROJECT_NAME,
    TASK: GC.ReportGroupingLevel.TASK,
    TASK_NAME: GC.ReportGroupingLevel.TASK_NAME,

    BILLING_TYPE: GC.ReportGroupingLevel.BILLING_TYPE,

    TT_COMMENTS: GC.ReportGroupingLevel.TT_COMMENTS,

    TASK_AND_TT_COMMENTS: GC.ReportGroupingLevel.TASK_AND_TT_COMMENTS,
    PROJECT_AND_TT_COMMENTS: GC.ReportGroupingLevel.PROJECT_AND_TT_COMMENTS,
    CUSTOMER_AND_TT_COMMENTS: GC.ReportGroupingLevel.CUSTOMER_AND_TT_COMMENTS,

    DATE: GC.ReportGroupingLevel.DATE,
    WEEK: GC.ReportGroupingLevel.WEEK,
    MONTH: GC.ReportGroupingLevel.MONTH
}

export const ReportType = {
    STAFF_PERFORMANCE: GC.ReportType.STAFF_PERFORMANCE,
    OVERTIME: GC.ReportType.OVERTIME,
    LEAVE_TIME: GC.ReportType.LEAVE_TIME,
    TIME_TRACK_IN_DETAIL: GC.ReportType.TIME_TRACK_IN_DETAIL,
    ESTIMATED_VS_ACTUAL: GC.ReportType.ESTIMATED_VS_ACTUAL,

    BILLING_SUMMARY: GC.ReportType.BILLING_SUMMARY,
    INVOICING: GC.ReportType.INVOICING,
    COST_OF_WORK: GC.ReportType.COST_OF_WORK,
    PROFIT_LOSS: GC.ReportType.PROFIT_LOSS
}

export const ReportChartType = {
    TOTAL_WORKING_HOURS: GC.ReportChartType.TOTAL_WORKING_HOURS,
    APPROVED_WORKING_HOURS: GC.ReportChartType.APPROVED_WORKING_HOURS,
    LEAVE_HOURS: GC.ReportChartType.LEAVE_HOURS,
    PTO_BALANCE: GC.ReportChartType.PTO_BALANCE,
    SICK_DAYS_BALANCE: GC.ReportChartType.SICK_DAYS_BALANCE,
    OVERTIME_HOURS: GC.ReportChartType.OVERTIME_HOURS,
    COST_OF_WORK: GC.ReportChartType.COST_OF_WORK,
    BILLABLE_AMOUNTS: GC.ReportChartType.BILLABLE_AMOUNTS
}

export const ChartType = {
    VERTICAL_BAR: GC.ChartType.VERTICAL_BAR,
    HORIZONTAL_BAR: GC.ChartType.HORIZONTAL_BAR,
    PIE_CHART: GC.ChartType.PIE_CHART
}

export const ChartSortOptions = {
    ALPHABETICALLY: GC.ChartSortOptions.ALPHABETICALLY,
    BY_VALUES: GC.ChartSortOptions.BY_VALUES,
    CHRONOLOGICALLY: GC.ChartSortOptions.CHRONOLOGICALLY
}

export const ChartColor = GC.ChartColor


// WEBPACK FOOTER //
// ./web/js/reports/constants.js